import React from 'react';
import Typography from '@material-ui/core/Typography';

const Subheader: React.FunctionComponent = ({ children }) => <Typography variant="h6">{children}</Typography>;

export { Subheader };
